import {PATTERN_PAINT_BOUNDS,patternTile} from './pattern-tiles.js';
import {patternDotPoints} from './dot-pattern.js';
import {patternPointCovered} from './pattern-erasure.js';

const primitives=new WeakMap(),paths=new Map();
let context;
function paintContext(){
  if(context)return context;
  if(typeof document==='undefined'||typeof Path2D==='undefined')return null;
  context=document.createElement('canvas').getContext('2d');return context;
}
function pathFor(d){if(!paths.has(d))paths.set(d,new Path2D(d));return paths.get(d);}
function compile(node,parent={fill:'black',stroke:'none',strokeWidth:1,strokeLinecap:'butt',opacity:1}){
  const props={...parent,...node.props,opacity:parent.opacity*(node.props.opacity??1)};
  if(node.children)return node.children.flatMap(child=>compile(child,props));
  const p=new Path2D();
  if(node.tag==='path')p.addPath(pathFor(props.d));
  if(node.tag==='rect')p.rect(props.x||0,props.y||0,props.width,props.height);
  if(node.tag==='ellipse')p.ellipse(props.cx,props.cy,props.rx,props.ry,0,0,Math.PI*2);
  if(node.tag==='polygon'){
    const coordinates=props.points.match(/-?\d+(?:\.\d+)?(?:e[+-]?\d+)?/g).map(Number);
    for(let i=0;i<coordinates.length;i+=2)i?p.lineTo(coordinates[i],coordinates[i+1]):p.moveTo(coordinates[i],coordinates[i+1]);p.closePath();
  }
  const translate=props.transform?.match(/translate\(([-\d.]+) ([-\d.]+)\)/);
  return[{path:p,props,x:translate?Number(translate[1]):0,y:translate?Number(translate[2]):0}];
}
export function pointInsideNail(point,nailPath){
  if(!nailPath)return true;
  const ctx=paintContext();return ctx?ctx.isPointInPath(pathFor(nailPath),point.x,point.y):false;
}
export function patternLocalPoint(layer,point){
  const angle=-(layer.rotation||0)*Math.PI/180,scale=layer.scale||1,dx=point.x-layer.x,dy=point.y-layer.y;
  const x=50+(dx*Math.cos(angle)-dy*Math.sin(angle))/scale,y=75+(dx*Math.sin(angle)+dy*Math.cos(angle))/scale;
  return{x:(layer.type==='dots'?layer.dotFlipX:layer.patternFlipX)?100-x:x,y};
}
export function patternPaintedAt(layer,point,{nailPath}={}){
  if(layer?.kind!=='pattern'||layer.visible===false||layer.opacity===0||!point||!Number.isFinite(point.x)||!Number.isFinite(point.y))return false;
  if(layer.clip!==false&&!pointInsideNail(point,nailPath))return false;
  const local=patternLocalPoint(layer,point),b=PATTERN_PAINT_BOUNDS;
  if(local.x<b.x||local.x>b.x+b.width||local.y<b.y||local.y>b.y+b.height)return false;
  if(layer.type==='dots')return patternDotPoints(layer).some(dot=>Math.hypot(local.x-dot.x,local.y-dot.y)<=dot.r);
  if(patternPointCovered(layer,local))return false;
  const ctx=paintContext();if(!ctx)return false;
  const tile=patternTile(layer.type);if(!primitives.has(tile))primitives.set(tile,compile(tile.art));
  const x=(local.x%tile.size+tile.size)%tile.size,y=(local.y%tile.size+tile.size)%tile.size;
  return primitives.get(tile).some(({path,props,x:ox,y:oy})=>{
    if(props.opacity<=0)return false;
    if(props.fill!=='none'&&ctx.isPointInPath(path,x-ox,y-oy))return true;
    if(props.stroke==='none')return false;
    ctx.lineWidth=props.strokeWidth;ctx.lineCap=props.strokeLinecap;ctx.lineJoin=props.strokeLinejoin||'miter';
    return ctx.isPointInStroke(path,x-ox,y-oy);
  });
}
